// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2tRTr","title":"AfterFrontImage_title__2WuIy"};